<script setup lang="ts">
import type { ContentScopeSubject } from '@/types/contentScope'

const props = defineProps<{
  isMineView: boolean
  subject: ContentScopeSubject
}>()

const emit = defineEmits<{
  reset: []
}>()

const { t } = useI18n()

const title = computed(() =>
  props.isMineView ? t('contentScope.filters.mineTitle') : t('contentScope.filters.noResultTitle')
)

const description = computed(() =>
  props.isMineView
    ? t(`contentScope.subjects.${props.subject}.mineDescription`)
    : t('contentScope.filters.noResultDescription')
)
</script>

<template>
  <div class="flex min-h-48 flex-col items-center justify-center gap-4 rounded-xl border bg-muted p-6 text-center">
    <div class="flex flex-col gap-1">
      <span class="text-base font-medium">{{ title }}</span>
      <span class="text-sm text-muted-foreground">{{ description }}</span>
    </div>
    <Button variant="outline" @click="emit('reset')">{{ t('contentScope.filters.resetFilters') }}</Button>
  </div>
</template>
